/**
 * Modèle PlayerAction - Identique à Flutter
 */

import {PlayerCondition} from './PlayerCondition';

export interface ActionObject {
  attributeId: string;
  value: string;
}

export interface PlayerAction {
  id: string;
  title: string;
  description?: string;
  conditions: PlayerCondition[];
  objects: ActionObject[];
  events?: any[];
  typeName?: string; // Pour l'exécution de l'action
  [key: string]: any;
}

export const ActionObjectFromJson = (json: any): ActionObject => {
  if (!json || typeof json.attributeId !== 'string') {
    throw new Error('Invalid ActionObject JSON: missing attributeId');
  }

  return {
    attributeId: json.attributeId,
    value: json.value || '',
  };
};

export const PlayerActionFromJson = (json: any): PlayerAction => {
  if (!json || typeof json.id !== 'string') {
    throw new Error('Invalid PlayerAction JSON: missing id');
  }

  return {
    id: json.id,
    title: json.title || json.id,
    description: json.description,
    conditions: (json.conditions as any[] || []).map((c) => {
      // PlayerCondition sera importé et parsé
      return c as any as PlayerCondition;
    }),
    objects: (json.objects as any[] || []).map((o) => ActionObjectFromJson(o)),
    events: json.events,
    typeName: json.typeName,
    ...json, // Conserver tous les autres champs
  };
};
